/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The type of formatting used for the contents of the reply.
 */
export const CommentReplyType = /* #__PURE__ */ parsers.exactly('plain_text', 'markdown');
